import { motion } from "framer-motion";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

const InstaIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const desktopActions = [
  { id: "randevu", label: "Randevu Al", href: "https://wa.me/905441199544?text=Merhaba%2C%20randevu%20almak%20istiyorum.", external: true, Icon: WhatsAppIcon, rose: true },
  { id: "ara", label: "Hemen Ara", href: "tel:+905441199544", external: false, Icon: PhoneIcon, rose: false },
  { id: "instagram", label: "Takip Et", href: "https://instagram.com/pureviaguzellikbursa", external: true, Icon: InstaIcon, rose: false },
];

const mobileIcons = [
  { id: "whatsapp", href: "https://wa.me/905441199544", external: true, Icon: WhatsAppIcon, rose: true },
  { id: "phone", href: "tel:+905441199544", external: false, Icon: PhoneIcon, rose: false },
  { id: "insta", href: "https://instagram.com/pureviaguzellikbursa", external: true, Icon: InstaIcon, rose: false },
];

export default function FixedSocialIcons() {
  return (
    <>
      {/* Desktop - pill buttons with labels */}
      <div
        data-testid="fixed-social-icons-desktop"
        className="fixed right-6 bottom-8 z-50 hidden md:flex flex-col gap-3"
      >
        {desktopActions.map((btn, i) => (
          <motion.a
            key={btn.id}
            href={btn.href}
            target={btn.external ? "_blank" : undefined}
            rel={btn.external ? "noopener noreferrer" : undefined}
            data-testid={`fixed-btn-${btn.id}`}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 2 + i * 0.6, ease: [0.22, 1, 0.36, 1] }}
            className={`flex items-center gap-3 rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300 pl-3 pr-5 py-2.5 ${
              btn.rose ? "bg-[#B76E79] text-white" : "bg-black text-white"
            }`}
          >
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 bg-white/15">
              <btn.Icon />
            </div>
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] whitespace-nowrap">
              {btn.label}
            </span>
          </motion.a>
        ))}
      </div>

      {/* Mobile - compact icon circles on right side */}
      <div
        data-testid="fixed-social-icons-mobile"
        className="fixed right-3 bottom-5 z-50 flex md:hidden flex-col gap-2"
      >
        {mobileIcons.map((btn, i) => (
          <motion.a
            key={btn.id}
            href={btn.href}
            target={btn.external ? "_blank" : undefined}
            rel={btn.external ? "noopener noreferrer" : undefined}
            data-testid={`fixed-mobile-${btn.id}`}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 2 + i * 0.15, ease: "backOut" }}
            className={`w-11 h-11 rounded-full flex items-center justify-center shadow-lg ${
              btn.rose ? "bg-[#B76E79] text-white" : "bg-black text-white"
            }`}
          >
            <btn.Icon />
          </motion.a>
        ))}
      </div>
    </>
  );
}
